import { T } from './theme';
// PasteVerbatimPanel — for FINISHED, already-signed provider notes pasted in
// from an outside EMR (ticket 3fe11107 / Headlands). The server places the
// pasted text word-for-word into narrative fields (substring-enforced) and
// NEVER rewords it. Checkboxes/choices/scales are left for the human.
// Deliberately a separate door from DictatePanel: dictation interprets,
// paste transcribes. Do not merge the two.
import React, { useState } from 'react';

const label = { fontSize:10, letterSpacing:'1.1px', textTransform:'uppercase', color:T.inkSoft, fontWeight:600 };
const input = { border:`1px solid ${T.b200}`, borderRadius:8, padding:'8px 11px',
  font:'inherit', color:T.ink, background:'#fff', boxSizing:'border-box', width:'100%' };
const btn = (primary) => ({ borderRadius:8, padding:'9px 16px', font:'inherit', fontWeight:600,
  fontSize:13, cursor:'pointer', background: primary ? T.rose : 'transparent',
  color: primary ? '#fff' : T.rose, border: primary ? 'none' : `1px solid ${T.b300}` });

export default function PasteVerbatimPanel({ onSubmit, busy, result }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  if (!open) return (
    <button style={{ ...btn(false), width:'100%' }} onClick={() => setOpen(true)}>
      📋 Paste a signed provider note → placed word-for-word</button>
  );

  return (
    <div>
      <div style={{ ...label, marginBottom:6 }}>Signed provider note (verbatim)</div>
      <textarea style={{ ...input, minHeight:130, fontSize:12.5 }} value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Paste the finished note here. It is placed into the form exactly as written — the AI only finds where each section belongs and never rewords anything. Checkboxes and selections are left for you. Nothing is signed." />
      <div style={{ fontSize:11.5, color:T.inkSoft, marginTop:4 }}>
        Word-for-word guarantee: any text that cannot be matched exactly to your paste is left blank, never rewritten.</div>
      <div style={{ display:'flex', gap:8, marginTop:8 }}>
        <button style={{ ...btn(true), flex:1 }} disabled={busy || !text.trim()}
          onClick={() => onSubmit(text)}>
          {busy ? 'Placing…' : 'Insert verbatim'}</button>
        <button style={btn(false)} disabled={busy} onClick={() => setOpen(false)}>✕</button>
      </div>
      {result || null}
    </div>
  );
}
